var _mask, _g, _mask2, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "star_svg__a",
    width: 27,
    height: 27,
    x: 5,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.08 2.842h26.38v25.263H5.08z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#star_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "m19.85 3.825 2.711 5.493c.256.52.753.88 1.328.963l6.061.88c1.446.211 2.024 1.987.977 3.007l-4.387 4.276a1.77 1.77 0 0 0-.507 1.56l1.036 6.037c.247 1.44-1.265 2.538-2.557 1.858l-5.422-2.85a1.77 1.77 0 0 0-1.64 0l-5.422 2.85c-1.292.68-2.804-.418-2.556-1.858l1.035-6.037a1.76 1.76 0 0 0-.507-1.56l-4.386-4.276c-1.046-1.02-.47-2.796.976-3.006l6.062-.881a1.76 1.76 0 0 0 1.327-.963l2.71-5.493c.648-1.31 2.515-1.31 3.162 0",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "star_svg__b",
    width: 17,
    height: 19,
    x: 5,
    y: 15,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5 15.049h16.08v18.567H5z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#star_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M18.415 24.746c-.316-.046-.638-.013-.952.028-.314.04-.623.095-.923.199-.363.125-.716.28-1.066.44q-.567.264-1.123.55-.485.248-.968.498c-.195.101-.391.212-.599.29-.017.008-.07.035-.09.021-.172-.105-.134-1.415.616-1.907.86-.566 3.567-2.86 3.567-2.86.658-.7 2.501-2.66 2.787-2.96.566-.595 1.501-1.74 1.41-2.756-.061-.662-.73-1.475-1.461-1.177-.19.077-.351.21-.51.34-3.295 2.716-6.819 5.226-10.276 7.764-.384.398-.713.849-1.031 1.284q-.241.334-.49.654l-.073.091c-.236.3-.456.581-.732.791-.097.073-.204.14-.313.209-.254.162-.542.344-.754.613-.315.4-.389.95-.417 1.328-.054.717.02 1.56.226 2.575.103.506.27 1.157.65 1.71.516.75 1.376 1.124 2.425 1.091.442-.013.888.073 1.327.05 1.19-.062 2.203-.767 3.138-1.433 1.425-1.015 2.78-2.207 4.298-3.121 1.122-.677 2.914-1.056 2.672-2.715-.101-.694-.606-1.49-1.338-1.597",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    fillRule: "evenodd",
    d: "M14.637 23.85s-1.095.861-1.327 1.015c-.75.492-.789 1.802-.617 1.907.09.054 1.844-.967 3.24-1.563 0 0-.129-.873-1.296-1.36",
    clipRule: "evenodd"
  })));
};
export default SvgStar;